import React from "react";
import { Route } from "react-router-dom";

/**
 * Wrapper route. Tiền tố ngôn ngữ (/en, /fr, ...) do BrowserRouter basename xử lý
 * (src/next/LegacySpaApp.js) và worker chuẩn hoá URL, nên không còn logic bóc /xx ở đây.
 */
const RoutesCustom = ({ component, render, path, ...rest }) => (
  <Route path={path} component={component} render={render} {...rest} />
);

export default RoutesCustom;
